import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AttendanceRoutingModule } from './attendance-routing.module';
import { AttendanceComponent } from './attendance/attendance.component';
import { AttendanceLinkComponent } from './attendance-link/attendance-link.component';
import { AttendanceLandingPageComponent } from './attendance-landing-page/attendance-landing-page.component';
import { AcademicFormModule } from '../academic-form/academic-form.module';
import { FilterdialogComponent } from './filterdialog/filterdialog.component';
import {MatSelectModule} from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { NgxSpinnerModule } from 'ngx-spinner';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';



@NgModule({
  declarations: [
    AttendanceComponent,
    AttendanceLinkComponent,
    AttendanceLandingPageComponent,
    FilterdialogComponent
  ],
  imports: [
    CommonModule,
    AttendanceRoutingModule,
    AcademicFormModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    // BrowserAnimationsModule,
    FormsModule,
    MatCardModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    ReactiveFormsModule,
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
    MatDatepickerModule,
    MatInputModule,
    MatProgressSpinnerModule


  ]
})
export class AttendanceModule { }
